export type PromptImageEditCandidate = {
  mediaType?: string | null;
  imageUrl?: string | null;
  adId?: string | null;
  status?: string | null;
};

/**
 * Fail-closed eligibility for the persisted prompt-and-mask image editor.
 * Callers must have a real generated_ads identity and a usable image URL.
 */
export function canOpenPromptImageEditor(candidate: PromptImageEditCandidate): boolean {
  const mediaType = candidate.mediaType ?? "image";
  const status = candidate.status ?? "ready";
  return (
    mediaType === "image" &&
    status === "ready" &&
    typeof candidate.adId === "string" &&
    candidate.adId.length > 0 &&
    typeof candidate.imageUrl === "string" &&
    candidate.imageUrl.length > 0
  );
}